/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchForLoadQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type SearchForLoadQuery = { __typename?: 'Query', trackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, docketId?: string | null, truckRegistration?: string | null, status?: Types.AssetStatus | null, scanEvents?: Array<{ __typename?: 'ScanEvent', createdAt?: any | null, createdByApplicationType?: string | null, scanEventType?: Types.ScanEventType | null, weight?: number | null, photos?: Array<{ __typename?: 'ScanEventPhoto', id: string, photoType?: Types.ScanEventPhotoType | null, photo?: { __typename?: 'GraphweaverMedia', url: string } | null }> | null }> | null, facilityCustomer?: { __typename?: 'FacilityCustomer', id: string, account: { __typename?: 'Account', name?: string | null, id: string } } | null, containsTrackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, intendedMaterial?: Types.MaterialType | null, scannableCode?: string | null, status?: Types.AssetStatus | null, containsTrackableAssets_aggregate?: { __typename?: 'AggregationResult', count: number } | null }> | null } | null> | null };

export type CreateInboundLoadMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.FacilityBaleInboundInput>;
}>;


export type CreateInboundLoadMutation = { __typename?: 'Mutation', facilityBaleInbound?: { __typename?: 'ScanEvent', id: string } | null };

export type UploadInboundBalePhotoMutationVariables = Types.Exact<{
  input: Types.ScanEventPhotoInsertInput;
}>;


export type UploadInboundBalePhotoMutation = { __typename?: 'Mutation', createScanEventPhoto?: { __typename?: 'ScanEventPhoto', id: string } | null };


export const SearchForLoadDocument = gql`
    query SearchForLoad($filter: TrackableAssetsListFilter) {
  trackableAssets(filter: $filter) {
    id
    assetType
    docketId
    truckRegistration
    status
    scanEvents {
      createdAt
      createdByApplicationType
      scanEventType
      weight
      photos {
        id
        photoType
        photo {
          url
        }
      }
    }
    facilityCustomer {
      id
      account {
        name
        id
      }
    }
    containsTrackableAssets {
      id
      assetType
      intendedMaterial
      scannableCode
      status
      containsTrackableAssets_aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useSearchForLoadQuery__
 *
 * To run a query within a React component, call `useSearchForLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForLoadQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchForLoadQuery(baseOptions?: Apollo.QueryHookOptions<SearchForLoadQuery, SearchForLoadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchForLoadQuery, SearchForLoadQueryVariables>(SearchForLoadDocument, options);
      }
export function useSearchForLoadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchForLoadQuery, SearchForLoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchForLoadQuery, SearchForLoadQueryVariables>(SearchForLoadDocument, options);
        }
export function useSearchForLoadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchForLoadQuery, SearchForLoadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchForLoadQuery, SearchForLoadQueryVariables>(SearchForLoadDocument, options);
        }
export type SearchForLoadQueryHookResult = ReturnType<typeof useSearchForLoadQuery>;
export type SearchForLoadLazyQueryHookResult = ReturnType<typeof useSearchForLoadLazyQuery>;
export type SearchForLoadSuspenseQueryHookResult = ReturnType<typeof useSearchForLoadSuspenseQuery>;
export type SearchForLoadQueryResult = Apollo.QueryResult<SearchForLoadQuery, SearchForLoadQueryVariables>;
export const CreateInboundLoadDocument = gql`
    mutation CreateInboundLoad($input: FacilityBaleInboundInput) {
  facilityBaleInbound(input: $input) {
    id
  }
}
    `;
export type CreateInboundLoadMutationFn = Apollo.MutationFunction<CreateInboundLoadMutation, CreateInboundLoadMutationVariables>;

/**
 * __useCreateInboundLoadMutation__
 *
 * To run a mutation, you first call `useCreateInboundLoadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInboundLoadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInboundLoadMutation, { data, loading, error }] = useCreateInboundLoadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInboundLoadMutation(baseOptions?: Apollo.MutationHookOptions<CreateInboundLoadMutation, CreateInboundLoadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInboundLoadMutation, CreateInboundLoadMutationVariables>(CreateInboundLoadDocument, options);
      }
export type CreateInboundLoadMutationHookResult = ReturnType<typeof useCreateInboundLoadMutation>;
export type CreateInboundLoadMutationResult = Apollo.MutationResult<CreateInboundLoadMutation>;
export type CreateInboundLoadMutationOptions = Apollo.BaseMutationOptions<CreateInboundLoadMutation, CreateInboundLoadMutationVariables>;
export const UploadInboundBalePhotoDocument = gql`
    mutation UploadInboundBalePhoto($input: ScanEventPhotoInsertInput!) {
  createScanEventPhoto(input: $input) {
    id
  }
}
    `;
export type UploadInboundBalePhotoMutationFn = Apollo.MutationFunction<UploadInboundBalePhotoMutation, UploadInboundBalePhotoMutationVariables>;

/**
 * __useUploadInboundBalePhotoMutation__
 *
 * To run a mutation, you first call `useUploadInboundBalePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInboundBalePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInboundBalePhotoMutation, { data, loading, error }] = useUploadInboundBalePhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadInboundBalePhotoMutation(baseOptions?: Apollo.MutationHookOptions<UploadInboundBalePhotoMutation, UploadInboundBalePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadInboundBalePhotoMutation, UploadInboundBalePhotoMutationVariables>(UploadInboundBalePhotoDocument, options);
      }
export type UploadInboundBalePhotoMutationHookResult = ReturnType<typeof useUploadInboundBalePhotoMutation>;
export type UploadInboundBalePhotoMutationResult = Apollo.MutationResult<UploadInboundBalePhotoMutation>;
export type UploadInboundBalePhotoMutationOptions = Apollo.BaseMutationOptions<UploadInboundBalePhotoMutation, UploadInboundBalePhotoMutationVariables>;